import type { NextPage } from "next";
import NextErrorComponent from "next/error";
import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import Loading from "~/components/common/parts/loading/Loading";
import { Page as Component } from "~/components/specifics/property_deals/[id]/Page";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";

export const PATH = (id: number): string => `/property_deals/${id}`;

const Home: NextPage = () => {
	const router = useRouter();
	const id = useIdQueryHandler();
	const propertyDealId = Number(id);

	if (!router.isReady) return <Loading isLoading />;

	if (!id || Number.isNaN(propertyDealId)) {
		return <NextErrorComponent statusCode={404} />;
	}

	return (
		<>
			<NskHead title="案件グループ" />
			<Component id={propertyDealId} />
		</>
	);
};
export default Home;
